import { TagInputEditor } from "@/components/TagInput/TagInputEditor";
import { getDefaultContactDirectoryEntity } from "@/models/contactDirectory";
import { CustomCellEditorProps } from "@ag-grid-community/react";
import { useAtomValue } from "jotai";

export const JobTitleTagEditor = ({
  value,
  onValueChange,
  stopEditing,
}: CustomCellEditorProps) => {
  const entity = getDefaultContactDirectoryEntity();
  const { data: record } = useAtomValue(entity.getObserveEntityRecordAtom());
  const tagOptions = record?.jobTitleTags;

  return (
    <TagInputEditor
      value={value}
      onValueChange={onValueChange}
      stopEditing={stopEditing}
      tagOptions={tagOptions || []}
      radius={0}
      size="lg"
      autoFocus={true}
    />
  );
};
